<template>
  <div class="workbench-tab">
    <div
      class="tab-item"
      v-for="item in workbenchTabList"
      :key="item.value"
      :class="{ active: item.value === innerWorkbenchTab }"
      @click="changeTabType(item.value)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    currentTab: Number,
    workbenchTabList: Array,
  },
  data() {
    return {};
  },
  computed: {
    innerWorkbenchTab: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.$emit('update:currentTab', value);
      },
    },
  },
  created() {},
  methods: {
    changeTabType(value) {
      this.innerWorkbenchTab = value;
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-tab {
  flex-grow: 1;
  align-self: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: flex-start;
  height: 44px;
  background: #fff;
  border-bottom: 1px solid #ededed;
  .tab-item {
    display: flex;
    align-items: center;
    color: #222222;
    font-size: 14px;
    height: 43px;
    position: relative;
    white-space: nowrap;
    margin-right: 20px;
    cursor: pointer;
    &:first-child {
      margin-left: 15px;
    }
    &:hover {
      color: #337eff;
    }
    &.active {
      color: #337eff;
      font-weight: 600;
      position: relative;
      &::after {
        content: '';
        width: 22px;
        height: 2px;
        background: #337eff;
        position: absolute;
        left: 50%;
        top: 35px;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
